import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import FormularioApp from "app/Core/Components/Formulario/FormularioApp";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "../../Core/Components/Confirmacao/ConfirmacaoApp";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import * as Actions from "./Store/Actions/EmpresaPessoaOrcamentoActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        border: "1px solid #d2d2d2",
    },
    cor: {
        color: theme.palette.text.primary,
    }
});

const newEmpresaPessoaOrcamentoState = {
    idparent: null,
    idparent: null,
    idpessoaformulario: null,
    tipo: null,
    formulario: {},
    requeridos: null
};

class EmpresaPessoaOrcamentoDialog extends XAPPComponent {

    state = { ...newEmpresaPessoaOrcamentoState };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.EmpresaPessoaOrcamento.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaOrcamento.error,
                variant: "error"
            });
            this.props.EmpresaPessoaOrcamento.error = null;
        }
        if (this.props.EmpresaPessoaOrcamento.warning) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaOrcamento.warning,
                variant: "warning"
            });
            this.props.EmpresaPessoaOrcamento.warning = null;
        }
        if (this.props.EmpresaPessoaOrcamento.info) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaOrcamento.info,
                variant: "success"
            });
            this.props.EmpresaPessoaOrcamento.info = null;
            if (!this.state.idpessoaformulario || this.state.idpessoaformulario === null) {
                this.props.formDialog.type = "edit";
                var obj = this.state.formulario;
                obj.idpessoaformulario = this.props.formDialog.props.id;
                this.setState({ idpessoaformulario: this.props.formDialog.props.id, formulario: obj });
            }
        }

        if (!prevProps.formDialog.props.open && this.props.formDialog.props.open) {
            var obj = { ...newEmpresaPessoaOrcamentoState };
            obj.idpessoa = this.props.xappRouteParams.empresa;
            obj.idparent = this.props.idparent;
            obj.tipo = this.props.tipo;
            obj.formulario = this.getDadosPessoa();

            if (this.props.formDialog.type === "edit" && this.props.formDialog.data) {
                var obj = { ...this.props.formDialog.data };
                obj.tipo = this.props.tipo;
                obj.formulario.idparent = obj.idparent;
            }

            this.setState(obj);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    closeComposeDialog = () => {
        this.props.formDialog.type === "edit" ? this.props.closeEditDialog() : this.props.closeNewDialog();
    };

    handleChangeFormulario = (_AForm) => {
        this.setState(_.set({ ...this.state }, "formulario", _AForm));
    };

    getDadosPessoa = () => {
        const { datapessoa, DadosEmpresa, xappRouteParams } = this.props;
        var AResponse = {};
        if (!_.isUndefined(datapessoa) && !_.isNull(datapessoa)) {
            Object.keys(datapessoa).forEach(key => {
                AResponse["cliente_" + key] = datapessoa[key];
            });
        }
        if (!_.isUndefined(DadosEmpresa) && !_.isNull(DadosEmpresa)) {
            if (!_.isUndefined(DadosEmpresa[xappRouteParams.empresa]) && !_.isNull(DadosEmpresa[xappRouteParams.empresa])) {
                var ADados = DadosEmpresa[xappRouteParams.empresa];
                Object.keys(ADados).forEach(key => {
                    AResponse["empresa_" + key] = ADados[key];
                });
            }
        }
        return AResponse;
    };

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state;

        if (Object.keys(formulario).length < 1 || requeridos === null) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    };

    excluir = () => {
        this.props.remove(this.state, this.props.xappRouteParams, this.props.idparent, this.props.tipo, this.props.foreingKey);
        this.closeComposeDialog();
    };

    setRequeridos = (_ARequeridos) => {
        this.setState(_.set({ ...this.state }, "requeridos", _ARequeridos));
    };

    render() {
        const { formDialog, template = null, save, xappRouteParams, idparent, tipo, foreingKey } = this.props;

        return (
            <XAPPDialog
                {...formDialog.props}
                id="EmpresaPessoaOrcamento"
                onClose={this.closeComposeDialog}
                fullScreen
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {formDialog.type === "new" ? "Novo formulário" : "Editar formulário"}
                        </Typography>
                        {formDialog.data && (
                            <LogRegistro
                                primaryKey={"idpessoaformulario"}
                                Log={formDialog.data}
                            />
                        )}
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.closeComposeDialog}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "px-24 py-12" }}>
                    <form autoComplete="on">
                        {!_.isNull(template) &&
                            <FormularioApp
                                Formulario={template}
                                onChange={this.handleChangeFormulario}
                                customProps={[]}
                                setRequeridos={this.setRequeridos}
                                data={this.state.formulario}
                                xappRouteParams={xappRouteParams}
                            />
                        }
                    </form>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    save(this.state, xappRouteParams, idparent, tipo, foreingKey);
                                }}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                            />
                            {formDialog.type === "edit" &&
                                <div className="flex justify-end">
                                    <ConfirmacaoApp
                                        id="PessoaFormulario"
                                        data="PessoaFormulario"
                                        type="button"
                                        disabled={!this.canBeSubmitted()}
                                        onConfirmation={this.excluir}
                                        mensagem={"Tem certeza que deseja excluir esse registro?"}
                                        xappRouteParams={xappRouteParams}
                                        icon={"delete"}
                                        label={md.mobile() === null && md.tablet() === null ? "Remover" : ""}
                                        className="bg-red hover:bg-red text-white"
                                    />
                                </div>
                            }
                            {formDialog.type === "edit" &&
                                <ImprimirApp
                                    data={JSON.stringify(this.state.formulario)}
                                    xappRouteParams={xappRouteParams}
                                    key="btnImprimir"
                                    id={"imprimirpessoaformulario"}
                                    label={""}
                                    idrelatorio={this.props.tipo}
                                    type="Button"
                                    className="bg-blue hover:bg-blue"
                                // column={this.getColumns(ARelatorio.campos)}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearTemplate: Actions.clearTemplate,
        closeEditDialog: Actions.closeEditDialog,
        closeNewDialog: Actions.closeNewDialog,
        save: Actions.save,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
        getTemplate: Actions.getTemplate
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaOrcamento, auth }) {
    return {
        formDialog: EmpresaPessoaOrcamento.formDialog,
        template: EmpresaPessoaOrcamento.template,
        EmpresaPessoaOrcamento: EmpresaPessoaOrcamento,
        DadosEmpresa: auth.user.dadosempresa,
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(EmpresaPessoaOrcamentoDialog));
